<template>
  <el-button
    class="ob-button"
    :class="[
      icon ? 'icon-button' : '',
      !bg ? 'text-button' : '',
      !icon && bg ? 'default-button': ''
    ]"
    :style="{
      width: width,
      height: height,
      '--el-button-bg-color': bg ? backgroundColor : 'transparent',
      '--el-button-disabled-bg-color': bg ? backgroundColor : 'transparent',
      '--el-button-text-color': bg ? fontColor : 'var(--text-primary)',
      '--el-button-disabled-text-color': bg ? fontColor : 'var(--text-primary)',
      '--icon-button-size': iconSize,
      '--icon-button-color': iconColor,
      '--el-button-border-color': border ? borderColor : backgroundColor,
    }"
    :disabled="disabled"
    @click="onCallBack"
  >
    <template v-if="!icon && !loading">
      <!-- 补充文案/图标 -->
      <slot></slot>
      <!-- 按钮文案 -->
      {{ text }}  
    </template>
    <!-- 图标型按钮 -->
    <svg-icon v-if="icon && !loading" :name="icon"/>
    <!-- 加载中 -->
    <svg-icon v-if="loading" name="icon-loading"/>
  </el-button>
</template>

<script setup>
  import { ref, watch, getCurrentInstance } from 'vue'

  const props = defineProps({
    // 按钮文案
    text: {
      type: String,
      default: '',
    },
    // 图标
    icon: {
      type: [String, Object],
      default: ''
    },
    // 图标大小
    iconSize: {
      type: [String, Number],
      default: '24px'
    },
    // 图标颜色，只适用于图标填充色为自定颜色currentColor
    iconColor: {
      type: String,
      default: 'var(--text-primary-reverse)'
    },
    // 字体颜色
    fontColor: {
      type: String,
      default: 'var(--text-primary-reverse)'
    },
    // 按钮背景色
    backgroundColor: {
      type: String,
      default: 'var(--theme)'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false
    },
    // 点击回调
    callBack: {
      type: Function
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: ''
    },
    bg: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true
    },
    borderColor: {
      type: String,
      default: 'var(--line)'
    },
  })
  const onCallBack = () => {
    if (props.callBack) {
      props.callBack()
    }
  }
</script>

<style lang="postcss" scoped>
.default-button {
  --el-font-size-base: 16px;
  --el-border-radius-base: var(--button-radius);
  --el-button-hover-bg-color: var(--el-button-bg-color) !important;
  --el-button-hover-text-color: var(--el-button-text-color);
  --el-button-hover-border-color: var(--el-button-border-color) !important;
  --el-button-active-bg-color: var(--el-button-bg-color) !important;
  --el-button-active-border-color: var(--el-button-bg-color) !important;
  height: var(--button-height);
  &:active {
    --el-button-active-bg-color: var(--el-button-bg-color) !important;
    --el-button-active-border-color: v-bind(border ? `var(--line)` : `var(--el-button-bg-color)`) !important;
    opacity: .8;
  }
}

 .text-button {
  --el-border: none;
  --el-button-bg-color: transparent;
  --el-button-hover-bg-color: transparent;
  --el-button-hover-text-color: transparent;
  --el-button-text-color: var(--text-primary);
  --el-button-hover-text-color: var(--el-button-text-color);
  --el-button-hover-border-color: var(--el-button-border-color);
  width: auto;
  &:active {
    --el-button-active-bg-color: var(--el-button-bg-color) !important;
    opacity: .8;
  }
}

.icon-button {
  --el-border-radius-base: 100px;
  --el-button-hover-bg-color: var(--el-button-bg-color);
  --el-button-hover-border-color: var(--el-button-border-color);
  --el-button-hover-text-color: var(--el-button-text-color);
  width: auto;
  height: auto;
  padding: calc(var(--icon-button-size) / 2);
  .svg-icon {
    width: var(--icon-button-size);
    height: var(--icon-button-size);
    color: var(--icon-button-color);
  }
}

.is-disabled {
  opacity: .3;
  &:active {
    opacity: .4;
  }
}
.icon-loading {
  animation: rotating 2s linear infinite;
}

.el-button+.el-button {
  margin-left: 8px;
}

.el-button {
  position: relative;
}

@media screen and (max-width: 600px) {
  .default-button {
    width: 220px;
  }
}

@media screen and (min-width: 600px) and (max-width: 840px){
  .default-button {
    width: 280px;
  }
}
</style>